// import React, { useMemo, useState } from "react";
// import TextStyles from "../../components/Elements/TextStyles/TextStyles";
// import { ReactComponent as Back } from "../../assets/svgs/back-button.svg";
// import { ReactComponent as GreenEye } from "../../assets/svgs/greenEye.svg";
// import { ReactComponent as GreenDelete } from "../../assets/svgs/delete.svg";
// import { Tables } from "../../components/Elements/Tables/Tables";
// import SearchBar from "../../components/Elements/Search/SearchBar";
// import CustomButton from "../../components/Elements/Buttons/CustomButtons";
// import CardsBorder from "../../components/Cards/CardsBorder";
// import CustomSwitch from "../../components/Elements/CustomSwitch/CustomSwitch";
// import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
// import { Button } from "antd";
// import { useNavigate } from "react-router-dom";
// import { Badge } from "../../components/Elements/TextStyles/Badge";
// import CustomerReportsFilter from "./DailogBox/CustomerReportsFilter";

// const CustomerReports = () => {
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [filterData, setFilterData] = useState("");
//   const navigate = useNavigate();
//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Customer Name", key: "customerName" },
//       { label: "Report Name", key: "reportName" },
//       { label: "User Id", key: "userId" },
//       { label: "Requested On", key: "RequestedOn" },
//       { label: <div className="pl-10">Status</div>, key: "status" },
//       { label: "Action", key: "action" },
//     ],
//     []
//   );

//   const tableData = useMemo(() => [
//     {
//       serial: 1,
//       customerName: "OffsetGo",
//       reportName: "BSRS Report",
//       userId: "#G0182",
//       status: (
//         <div className="flex justify-center">
//           <Badge text={"Sent for Approval"} />
//         </div>
//       ),
//       RequestedOn: "28/5/25",
//       action: (
//         <div
//           className="flex  gap-2"
//           onClick={() => {
//             navigate("/customer-reports/customer-report-details", {
//               state: {
//                 projectId: "687f33f252c5f7e62532d84e",
//                 clieId: "6847e833ad39eb63d41ccd67",
//               },
//             });
//           }}
//         >
//           <GreenEye />
//         </div>
//       ),
//     },
//     {
//       serial: 2,
//       customerName: "Ionic Digital",
//       reportName: "ESG Report",
//       userId: "#ID0168",
//       status: (
//         <div className="flex justify-center">
//           <Badge text={"Approved"} />
//         </div>
//       ),
//       RequestedOn: "29/5/25",
//       action: (
//         <div
//           className="flex  gap-2"
//           onClick={() => navigate("/customer-reports/customer-report-details")}
//         >
//           <GreenEye />
//         </div>
//       ),
//     },
//     {
//       serial: 3,
//       customerName: "DefineNext",
//       reportName: "Social Report",
//       userId: "#DN0256",
//       status: (
//         <div className="flex justify-center">
//           <Badge text={"Draft"} />
//         </div>
//       ),
//       RequestedOn: "30/5/25",
//       action: (
//         <div
//           className="flex  gap-2"
//           onClick={() => navigate("/customer-reports/customer-report-details")}
//         >
//           <GreenEye />
//         </div>
//       ),
//     },
//   ]);
//   return (
//     <div
//       style={{ padding: "40px", backgroundColor: "#fff" }}
//       className="h-screen"
//     >
//       <div>
//         <div>
//           <div
//             className="flex justify-end  text-xs"
//             style={{ fontFamily: "Calibri" }}
//           >
//             <p>Home</p>
//             <span> / </span>
//             <TextStyles color="gradient"> Customer Reports</TextStyles>
//           </div>
//           <div className="flex items-center  gap-2 text-xl  font-bold px-2">
//             {/* <Back /> */}
//             <div className="pt-4">
//               <TextStyles color="gradient"> Customer Reports</TextStyles>
//             </div>
//           </div>
//         </div>
//         <CardsBorder>
//           <div className="flex justify-between mb-4 px-6">
//             <div className="flex gap-4">
//               <div
//                 style={{
//                   background: "#B6D4D933",
//                   height: "40px",
//                 }}
//                 className="px-4   border border-gray-300 rounded-md text-gray-400 text-base font-light"
//               >
//                 <p
//                   style={{
//                     fontFamily: "Calibri",
//                     fontWeight: "300",
//                     fontSize: "16px",
//                     lineHeight: "24px",
//                     letterSpacing: "0%",
//                   }}
//                   className="pt-2"
//                 >
//                   TOTAL PROJECTS {tableData.length}
//                 </p>
//               </div>
//               <SearchBar
//                 width="300px"
//                 // onSearch={(value) => setSearchTerm(value)}
//               />
//             </div>
//             <div className="flex gap-4">
//               <Button
//                 onClick={() => setFilterOpen(true)}
//                 type="secondary"
//                 style={{
//                   background: "#B6D4D9",
//                   border: "solid 1px #06513D",
//                 }}
//                 className="text-[14px] text-[#06513D] font-normal px-4 py-6"
//               >
//                 <FilterIcon /> FILTER
//               </Button>
//             </div>
//           </div>
//           <Tables
//             data={tableData}
//             headers={headers}
//             // pageSize={pageSize}
//             // total={totalRecords}
//             // current={currentPage}
//             // onChange={handlePageChange}
//             // onSort={handleSort}
//           />
//         </CardsBorder>{" "}
//       </div>

//       {filterOpen && (
//         <CustomerReportsFilter
//           onOpen={filterOpen}
//           onClose={() => setFilterOpen(false)}
//           setFilterData={setFilterData}
//           initialStatus={filterData}
//         />
//       )}
//     </div>
//   );
// };

// export default CustomerReports;



import React, { useMemo, useState, useEffect, useCallback } from "react";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as GreenEye } from "../../assets/svgs/greenEye.svg";
import { Tables } from "../../components/Elements/Tables/Tables";
import SearchBar from "../../components/Elements/Search/SearchBar";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { Badge } from "../../components/Elements/TextStyles/Badge";
import CardsBorder from "../../components/Cards/CardsBorder";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
import CustomerReportsFilter from "./DailogBox/CustomerReportsFilter";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";

// const CustomerReports = () => {
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const navigate = useNavigate();
// // Dynamic status list - only 2 statuses
//   const statusList = ["in_process", "completed"];

//   // Status display mapping
//   const STATUS_DISPLAY = {
//     in_process: "In Process",
//     completed: "Completed",
//   };

//   // Get current status from API response
//   const currentStatus = reportDetails?.status || "in_process";

//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Customer Name", key: "customerName" },
//       { label: "Report Name", key: "reportName" },
//       { label: "User ID", key: "userId" },
//       { label: "Requested On", key: "requestedOn" },
//       { label: <div className="pl-10">Status</div>, key: "status" },
//       { label: "Action", key: "action" },
//     ],
//     []
//   );

//   // ✅ Format date
//   const formatDate = useCallback((dateString) => {
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}-${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}-${date.getFullYear()}`;
//   }, []);

//   // ✅ Fetch API
//   const fetchReports = useCallback(async () => {
//     try {
//       const res = await getApi({
//         apiUrl: API_URLS.GET_ALL_CUSTOMER_REPORTS(
//           currentPage,
//           pageSize,
//           searchTerm
//         ),
//       });

//       if (res.success) {
//         const apiData = res?.data?.data || [];
//         const pagination = res?.data?.pagination;

//         // Update pagination info from API response
//         setPageSize(pagination?.limit || 10);
//         setTotalRecords(pagination?.totalRecords || 0);

//         // Map the data
//         const mappedData = apiData.map((item, index) => ({
//           serial: (currentPage - 1) * pageSize + index + 1,
//           customerName: item?.client?.name || "N/A",
//           reportName: item?.report?.name || "N/A",
//           userId: item?.client?.userId || "N/A",
//           requestedOn: formatDate(item?.requested_on),
//           status: (
//             <div className="flex justify-center">
//               <Badge text={item?.status} />
//             </div>
//           ),
//           action: (
//             <div
//               className="flex gap-2 cursor-pointer"
//               onClick={() =>
//                 navigate("/customer-reports/customer-report-details", {
//                   state: {
//                     reportId: item?._id,
//                   },
//                 })
//               }
//             >
//               <GreenEye />
//             </div>
//           ),
//         }));

//         setTableData(mappedData);
//       }
//     } catch (error) {
//       console.error("Error fetching reports:", error);
//       setTableData([]);
//     }
//   }, [currentPage, searchTerm, pageSize, navigate, formatDate]);

//   const handlePageChange = useCallback((page) => {
//     setCurrentPage(page);
//   }, []);

//   const handleSearch = useCallback((value) => {
//     setSearchTerm(value);
//     setCurrentPage(1); // Reset to first page on search
//   }, []);

//   useEffect(() => {
//     fetchReports();
//   }, [fetchReports]);

//   return (
//     <div style={{ padding: "40px", backgroundColor: "#fff" }} className="h-screen">
//       <div className="flex justify-between mb-4 px-6">
//         <div className="flex gap-4">
//           <SearchBar width="300px" onSearch={handleSearch} />
//         </div>
//         <Button
//           onClick={() => setFilterOpen(true)}
//           style={{ background: "#B6D4D9", border: "solid 1px #06513D" }}
//           className="text-[14px] text-[#06513D] font-normal px-4 py-6"
//         >
//           <FilterIcon /> FILTER
//         </Button>
//       </div>

//       <CardsBorder>
//         <Tables
//           data={tableData}
//           headers={headers}
//           current={currentPage}
//           pageSize={pageSize}
//           total={totalRecords}
//           onChange={handlePageChange}
//         />
//       </CardsBorder>

//       {filterOpen && (
//         <CustomerReportsFilter
//           onOpen={filterOpen}
//           onClose={() => setFilterOpen(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default CustomerReports;
const CustomerReports = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  // Status display mapping
  const STATUS_DISPLAY = {
    in_process: "In Process",
    completed: "Completed",
    pending: "Pending",
    rejected: "Rejected",
  };

  // Function to get formatted status text
  const getStatusDisplay = useCallback((status) => {
    return STATUS_DISPLAY[status] || status;
  }, []);

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Customer Name", key: "customerName" },
      { label: "Report Name", key: "reportName" },
      { label: "User ID", key: "userId" },
      { label: "Requested On", key: "requestedOn" },
      { label: "Status", key: "status" },
      { label: "Action", key: "action" },
    ],
    []
  );

  // ✅ Format date
  const formatDate = useCallback((dateString) => {
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  }, []);

  // ✅ Fetch API
  const fetchReports = useCallback(async () => {
    try {
      const res = await getApi({
        apiUrl: API_URLS.GET_ALL_CUSTOMER_REPORTS(
          currentPage,
          pageSize,
          searchTerm
        ),
      });

      if (res.success) {
        const apiData = res?.data?.data || [];
        const pagination = res?.data?.pagination;

        // Update pagination info from API response
        setPageSize(pagination?.limit || 10);
        setTotalRecords(pagination?.totalRecords || 0);

        // Map the data
        const mappedData = apiData.map((item, index) => ({

          serial: (currentPage - 1) * pageSize + index + 1,
          customerName: item?.client?.organization?.name ||item?.client?.name|| "N/A",
          reportName: item?.report?.name || "N/A",
          userId: item?.client?.userId || "N/A",
          requestedOn: formatDate(item?.requested_on),
          status: (
            <div className="flex justify-center">
              <Badge text={getStatusDisplay(item?.status)} />
            </div>
          ),
          action: (
            <div
              className="flex gap-2 cursor-pointer text-center justify-center"
              onClick={() =>
                navigate("/customer-reports/customer-report-details", {
                  state: {
                    reportId: item?._id,
                    clientId: item?.client_id,
                    projectId: item?.project_id,
                  },
                })
              }
            >
              <GreenEye />
            </div>
          ),
        }));
        setTableData(mappedData);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      setTableData([]);
    }
  }, [currentPage, searchTerm, pageSize, navigate, formatDate, getStatusDisplay]);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleSearch = useCallback((value) => {
    setSearchTerm(value);
    setCurrentPage(1); // Reset to first page on search
  }, []);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  return (
    <div style={{ padding: "40px", backgroundColor: "#fff" }} className="h-screen">
      <div className="flex justify-between mb-4 px-6">
        <div className="flex gap-4">
          <SearchBar width="300px" onSearch={handleSearch} />
        </div>
        <Button
          onClick={() => setFilterOpen(true)}
          style={{ background: "#E6EDEB", border: "solid 1px #06513D" }}
          className="text-[14px] hover:!bg-[#F8F8F8] hover:!text-[#06513D] text-[#06513D] font-normal px-4 py-6"
        >
          <FilterIcon /> FILTER
        </Button>
      </div>

      <CardsBorder>
        <Tables
          data={tableData}
          headers={headers}
          current={currentPage}
          pageSize={pageSize}
          total={totalRecords}
          onChange={handlePageChange}
        />
      </CardsBorder>

      {filterOpen && (
        <CustomerReportsFilter
          onOpen={filterOpen}
          onClose={() => setFilterOpen(false)}
        />
      )}
    </div>
  );
};

export default CustomerReports;